import { render, staticRenderFns } from "./PropertyDeclarationOfTrust.vue?vue&type=template&id=5e20d73e&scoped=true&"
import script from "./PropertyDeclarationOfTrust.vue?vue&type=script&lang=js&"
export * from "./PropertyDeclarationOfTrust.vue?vue&type=script&lang=js&"
import style0 from "./PropertyDeclarationOfTrust.vue?vue&type=style&index=0&id=5e20d73e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e20d73e",
  null
  
)

export default component.exports